import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { Control, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { TimeInput } from "components/forms";

import {
  TimeRestrictionSchema,
  timeRestrictionSchema,
} from "../common/schemas";

type TimeRestrictionInputProps = {
  setValue: (
    fieldName: "time_restriction",
    value: TimeRestrictionSchema,
  ) => void;
  disabled?: boolean;
  control: Control<{ time_restriction?: Partial<TimeRestrictionSchema> }>;
};

export function TimeRestrictionInput({
  setValue,
  disabled,
  control,
}: TimeRestrictionInputProps) {
  const { t } = useTranslation();

  const timeRestriction = useWatch({ control, name: "time_restriction" });

  return (
    <>
      <RadioGroup
        onChange={(_, value) => {
          if (value == "24") {
            setValue("time_restriction", null);
          } else {
            setValue("time_restriction", timeRestrictionSchema.parse({}));
          }
        }}
        value={timeRestriction == null ? "24" : "custom"}
      >
        <FormControlLabel
          value={"24"}
          control={<Radio />}
          label={t("24_hours")}
          disabled={disabled}
        />
        <FormControlLabel
          value={"custom"}
          control={<Radio />}
          label={t("custom")}
          disabled={disabled}
        />
      </RadioGroup>
      {timeRestriction && (
        <>
          <TimeInput
            control={control}
            label={t("From")}
            fieldName={"time_restriction.start"}
            disabled={disabled}
          />
          <TimeInput
            control={control}
            label={t("To")}
            fieldName={"time_restriction.end"}
            disabled={disabled}
          />
        </>
      )}
    </>
  );
}
